import React from 'react';
import UserForm from './components/UserForm';
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
  return (
    <div className="container text-center">
      <UserForm/>
    </div>
  );
}

export default App;
